import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { NeuDropdown } from "../../components/data/NeuDropdown";
import { ItemNameField } from "./ItemNameField";
import { Field, ReadOnly, Section } from "./ItemFormParts";
import { nextCode } from "../../api/masterItems";

// القسم الأساسي: الاسم عربي/إنجليزي · كود المادة (معاينة حيّة للكود التالي حسب التصنيف) · الوحدة · الماركة.
export const ItemSectionBasic = ({ form, setForm, units, branchId, excludeId, onDuplicate }) => {
  const { t } = useTranslation();
  const [preview, setPreview] = useState("");
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  useEffect(() => {
    if (form.item_code || !form.accounting_category || !branchId) { setPreview(""); return; }
    nextCode(branchId, form.accounting_category).then((d) => setPreview(d.item_code)).catch(() => setPreview(""));
  }, [form.accounting_category, form.item_code, branchId]);

  return (
    <Section testid="item-section-basic">
      <ItemNameField form={form} setForm={setForm} branchId={branchId} excludeId={excludeId} onDuplicate={onDuplicate} />
      <Field label={t("purchases.items.code")}
             hint={!form.item_code && preview ? t("purchases.items.codePreviewHint") : null}>
        <ReadOnly testid="item-item_code" value={form.item_code || preview}
                  placeholder={form.accounting_category ? "…" : t("purchases.items.codeAuto")} />
      </Field>
      <Field label={t("purchases.items.uom")}>
        <NeuDropdown testid="item-unit" value={form.unit} onChange={(value) => setForm({ ...form, unit: value })}
                     options={(units.length ? units : [form.unit]).map((u) => ({ value: u, label: t(`purchases.units.${u}`, u) }))} />
      </Field>
      <Field label={t("purchases.items.brand")}>
        <NeuInput data-testid="item-brand" value={form.brand || ""} onChange={set("brand")}
                  placeholder={t("purchases.items.brandPlaceholder")} />
      </Field>
    </Section>
  );
};
